import { render, staticRenderFns } from "./DocumentId.vue?vue&type=template&id=17f791b8&"
import script from "./DocumentId.vue?vue&type=script&lang=ts&"
export * from "./DocumentId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports